const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const AT = require("../core/vault/ActionTypes");

const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const UpdateModal = require("./UpdateModal");
const CopyTable = require("./data/CopyTable");
const ClassesUtil = require("./util/ClassesUtil");
const EditPencil = require("../office/EditPencil");
const Editable = require("../office/Editable");

const styles = require("./styles/PageStaffProfile.css");
const accountBodyStyles = require("./styles/AccountBody.css");
const accountBodyHeaderStyles = require("./styles/AccountBodyHeader.css");
const accountUserStyles = require("./styles/AccountUser.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PageStaffProfile",

		propTypes: {
			user: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				updateInfo: null, // object with modal type and identifier (e.g. student ID, class ID, etc.)
				error: null,
				status: null, // status for modals
			};
		},

		componentDidMount: function() {
			// Fetch basic user info from Platform, including new email. Do
			// this every time user comes to this page because new email
			// can get verified or expire.
			this.props.dispatch({
				type: AT.LOAD_USER_PLATFORM_BASICS_REQUEST,
			});
		},

		vaultEvents: {
			schoolAccountActionSuccess: function() {
				this.updateModalInfo("success");
			},
			schoolAccountActionFail: function(err, moreInfo) {
				this.updateModalInfo("error", err);
			},
		},

		updateModalInfo(status, err) {
			const {updateInfo} = this.state;
			const isModalOpen = updateInfo;
			if (isModalOpen) {
				if (status === "success") {
					this.setState(this.resetState());
				} else if (status === "error") {
					this.setState({status: "error", error: err});
				}
			}
		},

		resetState() {
			return {
				updateInfo: null,
				status: null,
				error: null,
			};
		},

		showModal(modalType, contentType) {
			const newState = this.resetState();
			newState[modalType] = contentType;
			this.setState(newState);
		},

		closeModals() {
			this.setState(this.resetState());
		},

		updateValues(vals) {
			const {userID} = vals;
			const scope = "staff";
			if (vals.hasOwnProperty("firstName")) vals.displayName = vals.firstName;
			this.props.dispatch({
				type: AT.UPDATE_SCHOOL_ACCOUNTS_SCOPE_REQUEST,
				userID,
				purchaseID: _.get(this.props.user, "model.staffForPurchaseID"),
				vals,
				scope,
			});

			this.setState({status: "pending"});
		},

		getModalProps(modalType) {
			const {inputProps, title} = CopyTable.getInputFieldCopy(modalType);
			const onUpdate = vals =>
				this.updateValues(_.extend(_.omit(modalType, "type"), vals));

			return {inputProps, title, onUpdate};
		},

		render: function() {
			const {user} = this.props;
			const {updateInfo, status, error} = this.state;
			const {userID} = user;
			const userInfo = _.pick(user.model, [
				"email",
				"newEmail",
				"displayName",
				"firstName",
				"lastName",
			]);

			let modalEl;
			if (updateInfo) {
				const modalProps = this.getModalProps(updateInfo);
				if (updateInfo.type === "passwordSelf")
					modalProps.title = "Update Password";
				modalEl = (
					<UpdateModal
						identifier={"staffSelf-" + updateInfo.userID}
						updateFor={userInfo}
						{...modalProps}
						onClose={this.closeModals}
						status={status}
						error={error}
						subtitle={""}
					/>
				);
			}

			// Simplified version of AccountBodyHeader
			const headerEl = (
				<div className={accountBodyHeaderStyles.main}>
					<div className={accountBodyHeaderStyles.top}>
						<div className={accountBodyHeaderStyles.titleOuter}>
							<div className={accountBodyHeaderStyles.name}>
								<EditPencil
									onClick={() =>
										this.showModal("updateInfo", {
											type: "name",
											userID,
										})
									}
									className={accountBodyHeaderStyles.pencil}
								/>
								<span className={accountBodyHeaderStyles.bao}>{"F"}</span>
								<span className={accountBodyHeaderStyles.titleText}>
									{ClassesUtil.getUserName(userInfo)}
								</span>
							</div>
						</div>
					</div>
				</div>
			);

			// Simplified version of AccountUser
			const userEl = (
				<div className={accountUserStyles.teacher}>
					<div className={accountUserStyles.info}>
						<div className={accountUserStyles.email}>
							<div className={accountUserStyles.emailInner}>
								<span className={accountUserStyles.label}>Email:</span>
								<Editable
									className={accountUserStyles.labelText}
									text={userInfo.newEmail || userInfo.email}
									onClick={() =>
										this.showModal("updateInfo", {
											type: "email",
											userID,
										})
									}
								/>
							</div>
							{userInfo.newEmail && userInfo.newEmail !== userInfo.email ? (
								<div className={accountUserStyles.newEmail}>
									{CopyTable.getNewEmailCopy(userInfo.newEmail, userInfo.email)}
								</div>
							) : null}
						</div>
						<div
							className={accountUserStyles.passwordReset}
							onClick={() =>
								this.showModal("updateInfo", {
									type: "passwordSelf",
									userID,
								})
							}
						>
							Change password
						</div>
					</div>
				</div>
			);

			return (
				<div className={styles.main}>
					<div className={styles.title}>{"Profile"}</div>
					<div className={styles.content}>
						<div className={accountBodyStyles.content}>
							{headerEl}
							{userEl}
							{modalEl}
						</div>
					</div>
				</div>
			);
		},
	})
);
